import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  CLEAR_DRIVER_COMMISSION,
  CLEAR_DRIVER_COMMISSIONS,
  FLAG_DRIVER_COMMISSION_ACTIVITY,
  FLAG_GETTING_DRIVER_COMMISSIONS,
  GET_DRIVER_COMMISSION,
  GET_DRIVER_COMMISSIONS,
} from '../types';
import { DRIVER_COMISSION_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from '../../config/rest';
import { DRIVER_COMMISSION_PATH } from '../../config/paths';

const flagGettingDriverCommissions = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_DRIVER_COMMISSIONS,
    payload: flag,
  });

const clearDriverCommissions = () => (dispatch) =>
  dispatch({
    type: CLEAR_DRIVER_COMMISSIONS,
  });

const getDriverCommissions = (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingDriverCommissions(true));
    const query = tableFilters;
    const url = `${DRIVER_COMISSION_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const commissions = await response.json();
    dispatch({
      type: GET_DRIVER_COMMISSIONS,
      payload: commissions,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingDriverCommissions(false));
  }
};

const flagDriverCommissionActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_DRIVER_COMMISSION_ACTIVITY,
    payload: flag,
  });

const clearDriverCommission = () => (dispatch) =>
  dispatch({
    type: CLEAR_DRIVER_COMMISSION,
  });

const getDriverCommission = (id) => async (dispatch) => {
  try {
    dispatch(flagDriverCommissionActivity(true));
    const url = `${DRIVER_COMISSION_ENDPOINT}/${id}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const commission = await response.json();
    dispatch({
      type: GET_DRIVER_COMMISSION,
      payload: commission,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagDriverCommissionActivity(false));
  }
};

const deleteDriverCommission = (id) => async (dispatch) => {
  try {
    dispatch(flagDriverCommissionActivity(true));
    const url = `${DRIVER_COMISSION_ENDPOINT}/${id}`;
    const response = await fetch(url, DEFAULT_DELETE_CONFIG);
    await isErrorResponse(response, null, dispatch);
    toastr.success('Éxito', 'La comisión del conductor ha sido eliminada');
    dispatch(push(DRIVER_COMMISSION_PATH));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagDriverCommissionActivity(false));
  }
};

const updateDriverCommission = (id, data) => async (dispatch) => {
  try {
    dispatch(flagDriverCommissionActivity(true));
    const url = `${DRIVER_COMISSION_ENDPOINT}/${id}`;
    const response = await fetch(url, {
      ...DEFAULT_PUT_CONFIG,
      body: JSON.stringify(data),
    });
    await isErrorResponse(response, null, dispatch);
    toastr.success('Éxito', 'La comisión del conductor ha sido actualizada');
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagDriverCommissionActivity(false));
  }
};

const postDriverCommission = (data) => async (dispatch) => {
  try {
    dispatch(flagDriverCommissionActivity(true));
    const url = `${DRIVER_COMISSION_ENDPOINT}`;
    const response = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      body: JSON.stringify(data),
    });
    await isErrorResponse(response, null, dispatch);
    toastr.success('Éxito', 'La comisión del conductor ha sido creada');
    dispatch(push(DRIVER_COMMISSION_PATH));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagDriverCommissionActivity(false));
  }
};

export {
  getDriverCommissions,
  clearDriverCommissions,
  getDriverCommission,
  clearDriverCommission,
  deleteDriverCommission,
  updateDriverCommission,
  postDriverCommission
};
